import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function ReverseDialog({ target, onClose }) {
  const { user, bump } = useAuth();
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const isAdmin = user?.role === "admin";

  const submit = async () => {
    if (reason.trim().length < 3) return toast.error("Reason is required");
    setBusy(true);
    try {
      const { data } = await api.post("/reversals", { ledger: target._ledger, transaction_id: target._txn, reason });
      toast.success(data.status === "reversed" ? `Reversed. New entries: ${data.reversal_ids.join(", ")}` : "Reversal request sent for admin approval");
      bump();
      setReason("");
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="reverse-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{isAdmin ? "Reverse Transaction" : "Request Reversal"} — {target?._txn}</DialogTitle>
          <DialogDescription className="text-xs">
            Entry delete nahi hogi. System linked entries (VI/DSE/FL/Cash) ki counter reversal entry banayega taaki audit trail safe rahe.
            {!isAdmin && " Admin approval ke baad reversal hoga."}
          </DialogDescription>
        </DialogHeader>
        <Textarea placeholder="Reason (zaroori)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="reverse-reason-input" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="reverse-cancel-btn">Cancel</Button>
          <Button onClick={submit} disabled={busy} className="bg-violet-700 hover:bg-violet-800" data-testid="reverse-submit-btn">
            {busy ? "Working..." : isAdmin ? "Reverse now" : "Send request"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
